import { UIView } from "@uirouter/react";

export const DashboardRootContainerV2 = () => {
    return <UIView />;
};
